export const getTextBoolean = (value: boolean) => (value ? "TRUE" : "FALSE")
